import { selectOfferId } from 'shared/selectors';
import { getEtazhiBlackFridayPrice } from 'shared/services/etazhiBlackFriday';
import type { IThunkActionCreator } from 'shared/store';

import { setEtazhiBlackFridayPricesData } from './actions';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
export function fetchEtazhiBlackFridayPriceThunk(): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const state = getState();
    const offerId = selectOfferId(state);
    const parameters = { realtyOfferIds: [offerId] };

    const pricesData = await getEtazhiBlackFridayPrice({ httpApi, logger, parameters });

    dispatch(setEtazhiBlackFridayPricesData(pricesData));
  };
}
